import { buildSsrHeaders, getOrCreateSessionId } from "../../core/common/ssr-utils";
import { getCoursesUSupplierToken, getSsrBaseUrl } from "./coursesu-env.js";
import { getAvailableStores } from "./config-file";


function getCookie(name) {
  const cookieString =
    typeof document?.cookie === "string" ? document.cookie : "";
  if (!cookieString) return undefined;
  const parts = cookieString.split(";");
  for (const chunk of parts) {
    const part = chunk.trim();
    if (!part) continue;
    const eqIndex = part.indexOf("=");
    if (eqIndex === -1) continue;
    const key = part.substring(0, eqIndex).trim();
    if (key === name) {
      const raw = part.substring(eqIndex + 1);
      return decodeURIComponent(raw);
    }
  }
  return undefined;
}

export function getPosExtId() {
  return getCookie('storeId');
}

/**
 * Courses U TrustCommander (`TC_PRIVACY_CENTER`):
 * - Pending: cookie not set until the user accepts or refuses
 * - Accepted: value is `1,2,3,4` (stored as `1%2C2%2C3%2C4`); category `1` = function / profiling cookies
 * - Refused: cookie is present but its value is empty
 *
 * Only an explicit accept with category `1` allows profiling (`cookies-consent: true`).
 */
export function isProfilingAllowed() {
  const privacyCenter = getCookie('TC_PRIVACY_CENTER');

  if (privacyCenter === undefined || privacyCenter === '') {
    return false;
  }

  return privacyCenter.split(',').some(category => category.trim() === '1');
}

export async function buildCoursesUSSRHeaders(userId) {
  return buildSsrHeaders({
    language: "fr",
    supplierToken: getCoursesUSupplierToken(),
    userId: globalThis.loggedIn === true && userId != null ? String(userId) : undefined,
    sessionId: getOrCreateSessionId(),
    cookiesConsent: isProfilingAllowed(),
    baseUrl: getSsrBaseUrl(),
  });
}

export async function clearPreferences(userId) {
  localStorage.removeItem("_miam/preferences/guests");
  localStorage.removeItem("_miam/preferences");
  const loggedIn = globalThis.loggedIn === true;

  const baseUrl = getSsrBaseUrl();
  if (!baseUrl || userId == null || !loggedIn) {
    return;
  }

  try {
    await fetch(`${baseUrl}/v3/cache/remove`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: String(userId), key: "preferences" }),
    });
  } catch (error) {
    console.debug("[Mealz Injector] Failed to clear SSR preferences cache", error);
  }
}

/**
 * @returns true if the store is available
 */
export async function isAvailable() {
  const stores = await getAvailableStores();
  return stores.includes(getPosExtId());
}

/**
 * Check {times} times every {delay} ms to see if {variableToCheck} has been defined.
 * @param {any} object the parent object of the variable to test
 * @param {string} property the name of the property of the object
 * @param {number} delay time in ms between each check
 * @param {number} times
 * @returns true if variableToCheck is different from undefined when it checks it or false if it is still undefined after {times} checks
 */
export function waitForVariable(object, property, delay, times, callback) {
  const interval = setInterval(() => {
    if (object[property] !== undefined || times == 0) {
      clearInterval(interval);
      callback(object[property]);
    } else {
      times --;
    }
  }, delay);
}
